import React from 'react';
import classNames from 'classnames';
import { Tooltip } from 'antd';

export default class ControlButton extends React.Component {
  render() {
    const {
      icon,
      name,
      selected,
      defaultColor,
      disabled,
      onClick,
      title
    } = this.props;
    return (
      title !== '' ?
      <Tooltip placement="top" title={title}>
        <div
          className={classNames({
            'control-icon-text': !!name,
            'control-icon': !name,
            selected: !!selected,
            'default-color-red': !!defaultColor && 'red' == defaultColor,
            'default-color-blue': !!defaultColor && 'blue' == defaultColor,
            disabled: disabled
          })}
          onClick={!disabled && onClick}
        >
          {
            icon !== '' &&
            <i className={`iconfont ${icon}`} />
          }
          {name}
        </div>
      </Tooltip> :
      <div
        className={classNames({
          'control-icon-text': !!name,
          'control-icon': !name,
          selected: !!selected,
          'default-color-red': !!defaultColor && 'red' == defaultColor,
          'default-color-blue': !!defaultColor && 'blue' == defaultColor,
          disabled: disabled
        })}
        onClick={!disabled && onClick}
      >
        {
          icon !== '' &&
          <i className={`iconfont ${icon}`} />
        }
        {name}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ControlButton.js